/**
 * Web entry point.
 *
 * Registers the same `App` the native builds use. `AppRegistry.runApplication`
 * is react-native-web's mount path — using it rather than `createRoot`
 * directly is what gives the app the style reset and root sizing that RNW's
 * components expect.
 */

import { AppRegistry } from 'react-native';

import App from '../src/app/App';
import { name as appName } from '../app.json';
import { installWebStorage } from '../src/core/storage/webStorage';

// Persist the session across reloads. Native builds keep the in-memory
// default until secure storage is wired.
installWebStorage();

AppRegistry.registerComponent(appName, () => App);

const rootTag = document.getElementById('root');
if (!rootTag) {
  throw new Error('Missing #root element in index.html');
}

AppRegistry.runApplication(appName, { rootTag });
